export default __webpack_public_path__ + "b8f5cda09ff2c345eae0834b5f53b6cf.png";